export default __webpack_public_path__ + "static/media/sManagerLogo.8f04a323.svg";